import { render, staticRenderFns } from "./WeighingLog.vue?vue&type=template&id=607bbc15"
import script from "./WeighingLog.vue?vue&type=script&lang=js"
export * from "./WeighingLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports